export const NOTIFICATIONS_ACTIONS = {
  LIST: 'CUSTOMERS_NOTIFICATIONS_LIST',
  SMART_LIST: 'CUSTOMERS_NOTIFICATIONSSMART_LIST',
  VIEW: 'CUSTOMERS_NOTIFICATIONS_VIEW',
  UPDATE: 'CUSTOMERS_NOTIFICATIONS_UPDATE'
};